import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="audit-template-row">
      <div className="audit-template-col-no">{displayNo}</div>

      <div className="audit-template-col-title">
        <Link
          to={`/documents/audit-committee/${item.id}`}
          className="audit-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="audit-template-col-writer">{item.writer}</div>
      <div className="audit-template-col-date">{item.date}</div>
      <div className="audit-template-col-view">{item.view}</div>
    </div>
  );
}